import { Link } from 'react-router-dom';

const tools = [
  {
    title: 'Capital Gain Calculator',
    description: 'Upload your broker PDF and get a detailed capital gain report with tax calculation instantly.',
    icon: '📈',
    link: '/tools/capital-gain',
    badge: 'Free',
    badgeColor: 'bg-green-100 text-green-700',
  },
  {
    title: 'TDS Calculator',
    description: 'Enter expense type and get the applicable TDS section and rate using AI.',
    icon: '🧮',
    link: '/tools/tds-calculator',
    badge: 'Free',
    badgeColor: 'bg-green-100 text-green-700',
  },
  {
    title: 'Bank Statement to Excel',
    description: 'Convert any bank statement PDF to a clean, structured Excel file.',
    icon: '🏦',
    link: '/tools/bank-statement',
    badge: 'Coming Soon',
    badgeColor: 'bg-gray-100 text-gray-500',
  },
  {
    title: 'Property Capital Gain',
    description: 'Calculate capital gain on sale of property and explore Section 54 tax saving options.',
    icon: '🏠',
    link: '/tools/property-gain',
    badge: 'Coming Soon',
    badgeColor: 'bg-gray-100 text-gray-500',
  },
];

export default function Home() {
  return (
    <div>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-700 to-blue-900 text-white py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Smart Tax Tools for<br />Chartered Accountants
          </h1>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Save hours of manual work. Upload broker reports, calculate capital gains,
            and generate client-ready tax reports in minutes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/api/auth/google"
              className="bg-white text-blue-700 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition text-lg">
              Get Started Free
            </a>
            <Link to="/tools/capital-gain"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-700 transition text-lg">
              Try Capital Gain Tool
            </Link>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="bg-white py-10 border-b">
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-3 gap-8 text-center">
          <div>
            <div className="text-3xl font-bold text-blue-700">10+</div>
            <div className="text-gray-500 mt-1">CA Tools</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-blue-700">Free</div>
            <div className="text-gray-500 mt-1">To Get Started</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-blue-700">100%</div>
            <div className="text-gray-500 mt-1">Accurate</div>
          </div>
        </div>
      </div>

      {/* Tools Grid */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-4">
          Our Tools
        </h2>
        <p className="text-gray-500 text-center mb-12 max-w-2xl mx-auto">
          Built by a Chartered Accountant for CAs. Every tool is designed with
          deep understanding of Indian tax laws.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
          {tools.map((tool, idx) => (
            <Link
              key={idx}
              to={tool.link}
              className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md hover:border-blue-200 transition group">
              <div className="flex items-start justify-between mb-4">
                <span className="text-4xl">{tool.icon}</span>
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${tool.badgeColor}`}>
                  {tool.badge}
                </span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2 group-hover:text-blue-700 transition">
                {tool.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                {tool.description}
              </p>
            </Link>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-800 text-gray-400 py-8 text-center">
        <p className="text-sm">
          © 2026 TaxThinker. Built for Chartered Accountants in India.
        </p>
      </footer>
    </div>
  );
}
